<template>
  <div v-if="!isLoading" class="footer-notice">
    <ul>
      <li>
        <a href="#" @click.prevent="goNoticeList" class="text01">공지사항</a>
      </li>
      <li id="footer-notice" class="swiper-container">
        <ul class="swiper-wrapper">
          <li v-for="(notice, index) in noticeList" class="swiper-slide" :key="'notice_'+ index">
            <a href="#" class="text02" :title="'공지사항 (' + notice.bottom_text1 + ')으로 이동'">{{ notice.bottom_text1 }}</a>
          </li>
        </ul>
      </li>
      <li :id="'swiper-button-next-footer'" class="footer-arrow-left swiper-button-next">
        <a href="#"><img src="../../../assets/images/common/arrow-footer-left.png" alt="이전목록" /></a>
      </li>
      <li :id="'swiper-button-prev-footer'" class="footer-arrow-right swiper-button-prev">
        <a href="#"><img src="../../../assets/images/common/arrow-footer-right.png" alt="다음목록" /></a>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import Swiper from '@/mixins/swiper'
import { getUiserviceNotices } from '@/common/utils/request'
import { PATH_NAME_NOTICE_LIST } from '@/common/resources/router.const'

export default {
  mixins: [
    // IntegratedTemplate,
    Swiper
  ],
  data () {
    return {
      isLoading: true,
      noticeList: [],
      swiperOptions: {
        autoplay: 3500,
        direction: 'vertical',
        autoplayDisableOnInteraction: false,
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        nextButton: '#swiper-button-prev-footer',
        prevButton: '#swiper-button-next-footer',
        onClick: (swiper) => {
          const clickedSlideInfo = swiper.clickedSlide
          const idx = clickedSlideInfo.getAttribute('data-swiper-slide-index')
          // const idx = swiper.clickedSlide.dataset.swiperSlideIndex
          this.$router.push({
            name: 'notice_view',
            query: {
              noticeId: this.noticeList[idx].bottom_link.split('=').pop()
            }
          })
        },
        onTouchEnd: (swiper) => {
          this.$nextTick(() => {
            const idx = _.get(swiper, ['clickedSlide', 'dataset', 'swiperSlideIndex'], '')
            if (idx !== '') {
              this.$router.push({
                name: 'notice_view',
                query: {
                  noticeId: this.noticeList[idx].bottom_link.split('=').pop()
                }
              })
            }
          })
        }
      }
    }
  },
  methods: {
    goNoticeList () {
      this.$router.push({ name: PATH_NAME_NOTICE_LIST })
    }
  },
  created () {
    getUiserviceNotices({ type: 'all' }).then((response) => {
      this.noticeList = _.get(response, ['data', 'top_list', '0', 'bottom_list'], [])
      this.isLoading = false
      this.$nextTick(() => {
        this.swiperElement = '#footer-notice'
        this.isReady = true
      })
    })
  }
}
</script>
